module.exports = __webpack_public_path__ + "img/fga3.39481606.png";